import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getDestinationsTypesRedux = createAsyncThunk(
    "destinations/getdestinations",
    async (trackerId) => {
        let response;
        if (trackerId) {
            response = await axios.get(
                `${baseURL}/api/get-destination-types?tracker=${trackerId}`,
                RequestConfig(),
            );
        } else {
            response = await axios.get(
                `${baseURL}/api/get-destination-types`,
                RequestConfig(),
            );
        }
        return response.data;
    },
);
